// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ServiceLogResponse implements flatbuffers.IUnpackableObject<ServiceLogResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ServiceLogResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsServiceLogResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: ServiceLogResponse,
  ): ServiceLogResponse {
    return (obj || new ServiceLogResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsServiceLogResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: ServiceLogResponse,
  ): ServiceLogResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ServiceLogResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  floorName(): string | null;
  floorName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  floorName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  mode(): string;
  mode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  mode(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startServiceLogResponse(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addFloorName(builder: flatbuffers.Builder, floorNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, floorNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, dateOffset, 0);
  }

  static addMode(builder: flatbuffers.Builder, modeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, modeOffset, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(4, position, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(5, liftId, 0);
  }

  static endServiceLogResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // date
    builder.requiredField(offset, 10); // mode
    return offset;
  }

  static createServiceLogResponse(
    builder: flatbuffers.Builder,
    floorNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    modeOffset: flatbuffers.Offset,
    position: number,
    liftId: number,
  ): flatbuffers.Offset {
    ServiceLogResponse.startServiceLogResponse(builder);
    ServiceLogResponse.addFloorName(builder, floorNameOffset);
    ServiceLogResponse.addLiftName(builder, liftNameOffset);
    ServiceLogResponse.addDate(builder, dateOffset);
    ServiceLogResponse.addMode(builder, modeOffset);
    ServiceLogResponse.addPosition(builder, position);
    ServiceLogResponse.addLiftId(builder, liftId);
    return ServiceLogResponse.endServiceLogResponse(builder);
  }

  unpack(): ServiceLogResponseT {
    return new ServiceLogResponseT(
      this.floorName(),
      this.liftName(),
      this.date(),
      this.mode(),
      this.position(),
      this.liftId(),
    );
  }

  unpackTo(_o: ServiceLogResponseT): void {
    _o.floorName = this.floorName();
    _o.liftName = this.liftName();
    _o.date = this.date();
    _o.mode = this.mode();
    _o.position = this.position();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): ServiceLogResponseT {
    const t = new ServiceLogResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("floor_name")) {
      t.floorName = this.floorName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class ServiceLogResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public floorName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public mode: string | Uint8Array | null = null,
    public position: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.mode === null || this.mode === undefined) {
      throw new Error('Required field "mode" is not set');
    }
    const floorName = this.floorName !== null ? builder.createString(this.floorName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const mode = this.mode !== null ? builder.createString(this.mode!) : 0;

    return ServiceLogResponse.createServiceLogResponse(
      builder,
      floorName,
      liftName,
      date,
      mode,
      this.position,
      this.liftId,
    );
  }

  clone(): ServiceLogResponseT {
    const obj = new ServiceLogResponseT();
    obj.floorName = this.floorName;
    obj.liftName = this.liftName;
    obj.date = this.date;
    obj.mode = this.mode;
    obj.position = this.position;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: ServiceLogResponseT): boolean {
    if (this.floorName !== other.floorName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.date !== other.date) return false;
    if (this.mode !== other.mode) return false;
    if (this.position !== other.position) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyServiceLogResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "mode");
    verifier.checkScalarField(tablePos, 12, 2);
    verifier.checkScalarField(tablePos, 14, 2);
  } finally {
    verifier.popDepth();
  }
}
